import { GatewayEditFormValues, GatewayMethodFormValue } from 'pages/Gateways/GatewaysEdit/types';
import { useRecordContext } from 'react-admin';
import { useFieldArray, useFormContext } from 'react-hook-form';

export type GatewayMethodField = GatewayMethodFormValue & { id: string };

type UseGatewayMethodsFieldArrayReturnValues = {
  gatewayMethodFields: GatewayMethodField[];
  onAddGatewayMethod: (methodId: string, methodName: string) => void;
  onRemoveGatewayMethod: (index: number) => void;
};

export function useGatewayMethodsFieldArray(): UseGatewayMethodsFieldArrayReturnValues {
  const { control } = useFormContext();
  const record = useRecordContext<GatewayEditFormValues>();

  const {
    fields: gatewayMethodFields,
    append: appendGatewayMethod,
    remove: removeGatewayMethod,
  } = useFieldArray({
    name: 'gatewayMethods',
    control,
  });

  const onAddGatewayMethod = (methodId: string, methodName: string): void => {
    // если gatewayMethod был удален и снова добавлен пользователем до сохранения формы возвращаем его обратно
    const existingGatewayMethod = record?.gatewayMethods?.find(
      (gatewayMethod) => gatewayMethod.method === methodId,
    );
    if (existingGatewayMethod) {
      appendGatewayMethod(existingGatewayMethod);
      return;
    }
    appendGatewayMethod({
      active: true,
      autoDeactivation: false,
      pilotMode: false,
      gateway: record?.id,
      method: methodId,
      methodName: methodName,
    });
  };

  const onRemoveGatewayMethod = (index: number) => {
    removeGatewayMethod(index);
  };

  return {
    gatewayMethodFields: gatewayMethodFields as GatewayMethodField[],
    onAddGatewayMethod,
    onRemoveGatewayMethod,
  };
}
